import * as Common from '@/tenant/common';

export class PurchaseJournalReportQuery extends Common.ReportQuery {
    constructor(){
        super("PurchaseJournalReportQuery", null);
    }
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public counterpartCategory: Common.Category = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public bookDateFrom: Date = new Date().getCalendarDate();
    public bookDateTo: Date = new Date().getCalendarDate();
    public dueDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class PurchaseJournalReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='PurchaseJournalReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}
